export const texts = {
    label: {
        loading: 'Bitte warten'
    }
};

//# sourceMappingURL=LegacyButton.texts.js.map